var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"navigationCard",style:(_vm.disabled ? 'cursor: not-allowed' : ''),attrs:{"href":_vm.navigation}},[_c('v-icon',{staticClass:"ml-5",attrs:{"color":_vm.disabled ? 'grey' : '#004643',"x-large":""}},[_vm._v(" "+_vm._s(_vm.icons)+" ")]),_c('div',{class:_vm.disabled ? 'disabledCard' : 'enabledCard'},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }